"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _markdown = _interopRequireDefault(require("../markdown"));

var _galleryCarouselPropTypes = require("./gallery-carousel-prop-types");

var _lazyImage = _interopRequireDefault(require("../lazy-image"));

var _placeholderImage = _interopRequireDefault(require("../placeholder-image"));

require("./gallery-carousel-hero.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @typedef {object} GalleryCarouselItemData
 * @property {string} id Unique id for image
 * @property {string} heroUrl Image url
 * @property {string} heroPlaceholderUrl Placeholder URL, image is lazy loaded if provided
 * @property {string} heroNavTitle Title of the image
 * @property {string} description Markdown description of the large image
 */

/**
 * @typedef {object} GalleryCarouselHeroProps
 * @property {GalleryCarouselItemData} image
 * @property {object} style
 */

/**
 * The large image displayed under/above (mobile) the carousel navigation
 * @param {GalleryCarouselHeroProps} props
 */
var GalleryCarouselHero = function GalleryCarouselHero(_ref) {
  var image = _ref.image,
      lazy = _ref.lazy,
      style = _ref.style;

  var fullImage = /*#__PURE__*/_react["default"].createElement("img", {
    src: image.heroUrl,
    alt: image.heroNavTitle
  });

  var placeholderImage = image.heroPlaceholderUrl ? /*#__PURE__*/_react["default"].createElement(_placeholderImage["default"], {
    src: image.heroPlaceholderUrl,
    alt: image.heroNavTitle
  }) : null;
  var imageElement = placeholderImage && lazy ? /*#__PURE__*/_react["default"].createElement(_lazyImage["default"], {
    src: image.heroUrl,
    alt: image.heroNavTitle,
    placeholder: placeholderImage
  }) : fullImage;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "GalleryCarouselHero",
    style: style
  }, imageElement, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text"
  }, /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    source: image.description
  })));
};

GalleryCarouselHero.propTypes = {
  image: _galleryCarouselPropTypes.imagePropType.isRequired,
  lazy: _propTypes["default"].bool.isRequired,
  style: _propTypes["default"].shape({
    opacity: _propTypes["default"].string,
    transition: _propTypes["default"].string
  }).isRequired
};
var _default = GalleryCarouselHero;
exports["default"] = _default;